/** Normalized 0–1 coords for [`ShotLocation`]: 5 m line, middle. */
export const PENALTY_5M_CENTER_X = 0.5;
export const PENALTY_5M_CENTER_Y = 0.2;
